import { PayloadAction, createSlice } from '@reduxjs/toolkit';

// import { AuthResponse } from '../api/types.api';
import { Locales } from '../../common/interfaces';

export interface IInitialState {
  authLoading: boolean;
  accessToken: string | null;
  // userData: AuthResponse | null;
  lang: Locales;
  isMobile: boolean;
}

const initialState: IInitialState = {
  authLoading: true,
  accessToken: null,
  // userData: null,
  lang: Locales.RU,
  isMobile: false,
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setAuthLoading: (state, action: PayloadAction<boolean>) => {
      state.authLoading = action.payload;
    },

    setAccessToken: (state, action: PayloadAction<string | null>) => {
      state.accessToken = action.payload;
    },

    setMobile: (state, action: PayloadAction<boolean>) => {
      state.isMobile = action.payload;
    },

    // updateRefreshToken: (state, action: PayloadAction<string>) => {
    //   if (state.userData) {
    //     state.userData.refreshToken = action.payload;
    //   }
    // },

    // setUserData: (state, action: PayloadAction<AuthResponse | null>) => {
    //   state.userData = action.payload;
    // },
  },
});

export const {
  setAuthLoading,
  setAccessToken,
  setMobile,
  // setUserData,
  // updateRefreshToken,
} = commonSlice.actions;

export default commonSlice.reducer;
